export default __webpack_public_path__ + "static/media/About.39f0686e.svg";